import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import StatusIcon from 'modules/common/components/StatusIcon';

function Processor({ label, name, date, remarks }) {
  return (
    <>
      <tr>
        <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
          <b>{label}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark font-weight-bold" colSpan={8}>
          Name
        </td>
        <td colSpan={4}>
          <b>{name ? `${name}`.trim() : '-'}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark font-weight-bold" colSpan={8}>
          Date
        </td>
        <td colSpan={4}>
          <b>{date || '-'}</b>
        </td>
      </tr>
      {remarks !== "" && (
        <tr>
          <td className="text-dark font-weight-bold" colSpan={8}>
            Remarks
          </td>
          <td colSpan={4}>
            <b>{remarks || '-'}</b>
          </td>
        </tr>
      )}
      <tr className="bg-white">
        <td className="min-h-6 bg-white">
          <br />
        </td>
      </tr>
    </>
  );
}

Processor.defaultProps = {
  label: '',
  name: '',
  date: '',
  remarks: '',
};

Processor.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  date: PropTypes.string,
  remarks: PropTypes.string,
};

function TransactionInformation({ data, transactionList, viewEsoa, generatePermit }) {
  const spanGap = 8;
  const transmitallNo = get(
    data,
    'included.ebplsApplication.attributes.transmittal_no'
  );

  return (
    <>
      <div className="p-3" style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-striped table-sm">
          <tbody>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Permit Type
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.permit_type') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Transaction Type
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.transaction_type') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Transaction Status
              </td>
              <td colSpan={4}>
                <StatusIcon
                  value={get(data, 'attributes.transaction_status')}
                />
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Transaction No.
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.transaction_number') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Date
              </td>
              <td colSpan={4}>
                <b>{moment(get(data, 'attributes.transaction_date')).format('YYYY-MM-DD HH:mm') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Valid ID to Present
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.valid_id_to_present') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Transmittal No.
              </td>
              <td colSpan={4}>
                <b>{transmitallNo || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                TXN ID
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.txnid') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Reference No.
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.refno') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                Remarks
              </td>
              <td colSpan={4}>
                <b>
                  <pre style={{ color: '#7790cb' }}>
                    {get(
                      data,
                      'included.ebplsApplication.attributes.reject_remarks'
                    ) || '-'}
                  </pre>
                </b>
              </td>
            </tr>
            <tr className="bg-white">
              <td className="min-h-6 bg-white">
                <br />
              </td>
            </tr>
            <tr>
              <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
                <b>Payment Information</b>
              </td>
            </tr>
            {_.get(data, 'attributes.transaction_type') === "RENEWAL" ? (
              <tr className="bg-white">
                <td colSpan={12} style={{ maxWidth: '35rem', overflowX: 'scroll' }}>
                  <table className="transaction-table table table-borderless table-striped table-sm" style={{ width: '70rem' }}>
                    <tbody>
                      <tr>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Payment
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Status
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Amount
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Ref No.
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Billing No.
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold">
                          Billing Date
                        </th>
                        <th className="cms-bg-color-primary-light" />
                      </tr>
                      {!_.isEmpty(transactionList) && 
                        (transactionList?.length !== 1 || 
                        !_.isEmpty(_.get(transactionList, '0.attributes.soa_generated_at'))) ? (
                        transactionList.map((item) => (
                          <React.Fragment key={item.id}>
                            <tr>
                              <td>{_.get(item, "included.ebplsApplication.attributes.payment_qtr") || "-"}</td>
                              <td>               
                                <StatusIcon
                                  value={_.get(item, "attributes.status") || "-"}
                                />       
                              </td>
                              <td>{`PHP ${_.get(item, "included.ebplsApplication.attributes.total") || "-"}`}</td>
                              <td>{_.get(item, "attributes.refno") || "-"}</td>
                              <td>{_.get(item, "included.ebplsApplication.attributes.billing_no") || "-"}</td>
                              <td>{_.get(item, "included.ebplsApplication.attributes.billing_date") || "-"}</td>
                              <td>
                                <button 
                                  type="button"
                                  className="btn btn-link cms-text-primary mx-2 p-0" 
                                  onClick={viewEsoa}
                                >
                                  <i className="fas fa-eye" /> View ESOA
                                </button>
                                {_.get(item, "attributes.status") === "PAID" && (!_.get(data, 'included.ebplsApplication.attributes.sanitary_permit_generated_at') ||
                                !_.get(data, 'included.ebplsApplication.attributes.business_permit_generated_at')) && (
                                  <button 
                                    type="button"
                                    className="btn btn-link cms-text-primary mx-2 p-0" 
                                    onClick={generatePermit}
                                  >
                                    <i className="fas fa-money-bill" /> Generate Permit
                                  </button>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))
                      ) : (
                        <tr className="text-dark text-center">
                          <td className="text-dark text-center" colSpan="12">
                            No Payments
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <td className="text-dark font-weight-bold" colSpan={spanGap}>
                    Channel
                  </td>
                  <td colSpan={4}>
                    <b>{get(data, 'attributes.payment_channel') || '-'}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" colSpan={spanGap}>
                    Branch
                  </td>
                  <td colSpan={4}>
                    <b>{get(data, 'attributes.payment_channel_branch') || '-'}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" colSpan={spanGap}>
                    Date
                  </td>
                  <td colSpan={4}>
                    <b>{get(data, 'attributes.payment_date') ? moment(get(data, 'attributes.payment_date')).format('YYYY-MM-DD HH:mm') : '-'}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" colSpan={spanGap}>
                    Status
                  </td>
                  <td colSpan={4}>
                    <b>{get(data, 'attributes.status') || '-'}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark font-weight-bold" colSpan={spanGap}>
                    Amount
                  </td>
                  <td colSpan={4}>
                    <b>{get(data, 'attributes.amount') || '-'}</b>
                  </td>
                </tr>
                <tr className="bg-white">
                  <td className="min-h-6 bg-white">
                    <br />
                  </td>
                </tr>
              </>
            )}
            <tr>
              <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
                <b>No. of Days Aging</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                No. of Days Aging (Current)
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.no_of_days_aging_current') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark font-weight-bold" colSpan={spanGap}>
                No. of Days Aging (Overall)
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.no_of_days_aging_overall') || '-'}</b>
              </td>
            </tr>
            <tr className="bg-white">
              <td className="min-h-6 bg-white">
                <br />
              </td>
            </tr>
            <Processor
              label="Verifying By"
              name={get(data, 'attributes.verified_by_fullname')}
              date={get(data, 'attributes.verified_at')}
            />
            <Processor
              label="Planning Department Assessment Assessed By"
              name={get(data, 'attributes.planning_assessed_by_fullname')}
              date={get(data, 'attributes.planning_assessed_at')}
              remarks={get(data, 'attributes.planning_department_remarks')}
            />
            <Processor
              label="Engineering Department Assessment Assessed By"
              name={get(data, 'attributes.engineering_assessed_by_fullname')}
              date={get(data, 'attributes.engineering_assessed_at')}
            />
            <Processor
              label="Assessed By"
              name={get(data, 'attributes.assessed_by_fullname')}
              date={get(data, 'attributes.assessed_at')}
            />
            <Processor
              label="Rejected By"
              name={get(data, 'attributes.reject_by_full_name')}
              date={get(data, 'attributes.reject_at')}
            />
            <Processor
              label="Released By"
              name={get(data, 'attributes.released_by_full_name')}
              date={get(data, 'attributes.released_at')}
            />
            <Processor
              label="E-SOA generated By"
              name={get(
                data,
                'included.ebplsApplication.attributes.soa_generated_by'
              )}
              date={get(
                data,
                'included.ebplsApplication.attributes.soa_generated_at'
              )}
            />
          </tbody>
        </table>
      </div>
    </>
  );
}


TransactionInformation.defaultProps = {
  transactionList: [],
}
TransactionInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  viewEsoa: PropTypes.instanceOf(Function).isRequired,
  generatePermit: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array),
};

export default TransactionInformation;
